<template>
	<div class="online-service-box" @click="clickOnline">
		<img src="../assets/img/icon_online-message.png" alt="在线留言" />
		<!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=3235393303&amp;site=qq&amp;menu=yes">
			<img border="0" class="serviceImg" src="../assets/img/serviceQQ.png" object-fit = contain alt="点击这里给我发消息" title="点击这里给我发消息" />
		</a>  -->
	</div>
</template>

<script>
	export default{
		name: 'onlineService',
		methods: {
			clickOnline() {
				// return
				const onlineRouter = this.$router.resolve('/message')
				window.open(onlineRouter.href, '_blank')
			}
		}
	}
</script>

<style scoped>
	.online-service-box {
		display: none;
		width: 150px;
		position: fixed;
		top: 500px;
		right: 10px;
		cursor: pointer;
	}
	
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.online-service-box {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService.vue